export default __webpack_public_path__ + "static/media/i4.1e023f7c.webp";